import { Container, FormControl, Grid, Paper, TextField, Typography, Button, Alert } from "@mui/material";
import { redirect, useActionData, useLocation, useNavigation, useSubmit } from "react-router-dom";
import { useForm } from "react-hook-form";
import KeyIcon from '@mui/icons-material/Key';
import { useEffect } from "react";
import Cookies from 'universal-cookie';
import axios from "axios";
import jsonToFormData from "../hooks/jsonToFormData";
import AuthProvider from "../hooks/authProvider";
import PageTitle from "../components/PageTitle";

export async function loader({ request, params }) {
    if (await AuthProvider.checkAuth()) {
        return redirect('/');
    }
    return null;
}

export async function action({ request, params }) {
    const formData = await request.formData();
    try {
        await AuthProvider.signin(formData);
    } catch (e) {
        return {
            status: e.response?.status || 500,
            message: e.response?.status === 400 || e.response?.status === 401
                ? 'Невірний email або пароль'
                : 'Не вдалося отримати профіль користувача',
        };
    }
    const redirectTo = formData.get("redirectTo");
    const safeRedirect = redirectTo && redirectTo !== '/login' && !redirectTo.startsWith('/adminH123H')
        ? redirectTo
        : '/calendar';
    return redirect(safeRedirect);
}

export default function LoginPage() {
    const actionData = useActionData();
    const location = useLocation();
    const params = new URLSearchParams(location.search);

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const submit = useSubmit();
    const from = params.get("from") || "";

    const handleFormSubmit = (data) => {
        const formData = jsonToFormData(data);
        formData.append('redirectTo', from); // Добавляем путь для редиректа
        submit(formData, {
            encType: 'multipart/form-data',
            method: 'post'
        });
    };

    const navigation = useNavigation();
    return (
        <>
            <PageTitle title="Вхід до системи" />
            <Container maxWidth='xs' style={{ height: '100vh', display: 'flex', alignItems: 'center' }}>
                <Paper style={{ padding: '15px' }}>
                    <form onSubmit={handleSubmit(handleFormSubmit)}>
                        <Grid container spacing={2}>
                            <Grid item container style={{ justifyContent: 'center' }}>
                                <Typography variant='h5'>Вхід</Typography>
                            </Grid>
                            {/* Обработка ошибок */}
                            {actionData && actionData.status !== 200 && (
                                <Grid item xs={12}>
                                    <Alert severity='error'>Невдача! {actionData.message}</Alert>
                                </Grid>
                            )}
                            <input type="hidden" name="redirectTo" value={from} />
                            <Grid item container>
                                <FormControl fullWidth>
                                    <TextField
                                        type='email'
                                        label='Email'
                                        {...register('email', {
                                            required: "Обов'язкове поле",
                                            pattern: {
                                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                message: "Неправильний формат електронної пошти"
                                            }
                                        })}
                                        error={!!errors.email}
                                        helperText={errors.email ? errors.email.message : ''}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item container>
                                <FormControl fullWidth>
                                    <TextField
                                        type='password'
                                        label='Пароль'
                                        {...register('password', {
                                            required: "Обов'язкове поле",
                                        })}
                                        error={!!errors.password}
                                        helperText={errors.password ? errors.password.message : ''}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item container>
                                <FormControl fullWidth>
                                    <Button
                                        startIcon={<KeyIcon />}
                                        disabled={navigation.state === 'submitting'}
                                        variant='contained'
                                        type='submit'
                                        style={{ textTransform: 'uppercase' }}
                                    >
                                        Увійти
                                    </Button>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </form>
                </Paper>
            </Container>
        </>
    );
}
